export default {
  BUTTON_CLICK: 'BUTTON_CLICK',
  DRAG_AND_DROP: 'DRAG_AND_DROP',
};



// WEBPACK FOOTER //
// ./src/shared/constants/upload-types.js